import { render, staticRenderFns } from "./goodsBox.vue?vue&type=template&id=4ae96984&scoped=true"
import script from "./goodsBox.vue?vue&type=script&lang=js"
export * from "./goodsBox.vue?vue&type=script&lang=js"
import style0 from "./goodsBox.vue?vue&type=style&index=0&id=4ae96984&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae96984",
  null
  
)

export default component.exports